import React from 'react';
import { Modal, Layout } from 'antd';
import { Link } from 'react-router-dom';


const PayoutModalUI = props => (
  <Modal
    visible={props.visible}
    onCancel={props.onCancel}
    footer={null}
    width="800px"
    bodyStyle={{backgroundColor:"#f9f9f9"}}
  >
    <Layout className="layout" style={{minWidth:'500px'}}>
      <Layout.Content style={{ padding: '0 50px', paddingBottom:'50px', backgroundColor:'#f9f9f9'}}>
        <Link to="/">
          <div className="mojitok-bi mojitok-bi-payout"><img src={require("../../../img/mojitok-bi-black@2x.png")} width={200} alt=""/></div>
        </Link>
        <div className="container">
          <div className="outer">
            <div className="inner">
              <div className="centered">
                <div className="content" style={{width: 700, minHeight: 0}}>
                  <div style={{margin:'auto', paddingTop:100, paddingLeft:80}} >
                    {props.payoutForm}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout.Content>
    </Layout>

  </Modal>
);

export default PayoutModalUI